import MUITextField from '@mui/material/TextField';
import {bool, object, string} from 'prop-types';
import React, {useCallback} from 'react';
import {useController, useFormContext, useFormState} from 'react-hook-form';
import {toDateString, toISOString} from '../../utils.js';

export const utcDateTransform = {
  input: toDateString,
  output: event => {
    const dateString = event.target.value;
    return toISOString(dateString);
  },
};

function TextField({name, rules = {}, defaultValue = '', transform, ...props}) {
  const {control} = useFormContext();
  const {field} = useController({name, control, rules, defaultValue});
  const {errors} = useFormState({control, name});

  const errorMessage = errors[name] && errors[name].message;

  let required;
  if (typeof rules.required === 'object') {
    required = rules.required.value;
  } else {
    required = !!rules.required;
  }
  if ('required' in props && props.required !== required) {
    required = props.required;
    rules.required = required;
  }

  const value = transform?.input ? transform.input(field.value) : field.value;
  const onChange = useCallback(
    (...args) =>
      transform?.output
        ? field.onChange(transform.output(...args))
        : field.onChange(...args),
    [field, transform],
  );

  return (
    <MUITextField
      onChange={onChange}
      onBlur={field.onBlur}
      value={value}
      name={field.name}
      inputRef={field.ref}
      required={required}
      error={name in errors}
      helperText={errorMessage}
      {...props}
    />
  );
}

TextField.propTypes = {
  name: string.isRequired,
  label: string.isRequired,
  transform: object,
  defaultValue: string,
  rules: object,
  required: bool,
};

export default TextField;
